/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamMerchantPosResponseDtoDto } from '../models/pam-merchant-pos-response-dto-dto';


/**
 * the PmaGetPosIdNumber API
 */
@Injectable({
  providedIn: 'root',
})
export class PmaGetPosIdNumberService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fetchPosNumber
   */
  static readonly FetchPosNumberPath = '/payment/merchant/pos';

  /**
   * Get POS number for merchant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchPosNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchPosNumber$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PamMerchantPosResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PmaGetPosIdNumberService.FetchPosNumberPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PamMerchantPosResponseDtoDto>;
      })
    );
  }

  /**
   * Get POS number for merchant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetchPosNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchPosNumber(params?: {
  },
  context?: HttpContext

): Observable<PamMerchantPosResponseDtoDto> {

    return this.fetchPosNumber$Response(params,context).pipe(
      map((r: StrictHttpResponse<PamMerchantPosResponseDtoDto>) => r.body as PamMerchantPosResponseDtoDto)
    );
  }

}
